module.exports = __webpack_public_path__ + "static/media/modal-ic-adm.112a9c51.svg";